import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/**
 * Do not show cookie banner for a certain page, e.g. the login page.
 */
var preDecisionGatewayHasPageClass = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var className;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            className = document.body.className;
            return _context.abrupt("return", className.indexOf("login-action-") > -1 ? "consent" : false);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function preDecisionGatewayHasPageClass() {
    return _ref.apply(this, arguments);
  };
}();

export { preDecisionGatewayHasPageClass };